import './contact.svelte.css.proxy.js';
/* src/routes/contact.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	add_flush_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	noop,
	prevent_default,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import { onMount } from "../../_snowpack/pkg/svelte.js";
import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/contact/Title.svelte.js";
import Heading from "../../_components/contact/Heading.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";
import Line from "../../_components/form/Line.svelte.js";
import TextInput from "../../_components/form/TextInput.svelte.js";
import TelInput from "../../_components/form/TelInput.svelte.js";
import EmailInput from "../../_components/form/EmailInput.svelte.js";
import TextArea from "../../_components/form/TextArea.svelte.js";
import RadioInput from "../../_components/form/RadioInput.svelte.js";
import Submit from "../../_components/form/Submit.svelte.js";
import { loading } from "../../_components/page/index.js";
import { basePath } from "../../_config/navigation.js";

function create_default_slot_21(ctx) {
	let breadcrumb;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[9] } });

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
		}
	};
}

// (146:2) <Section kind="top-small">
function create_default_slot_20(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_21] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (154:2) <Wrap fullOnMobile>
function create_default_slot_19(ctx) {
	let title;
	let current;
	title = new Title({});

	return {
		c() {
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
		}
	};
}

// (153:0) <Section kind="gapless">
function create_default_slot_18(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_19] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (161:4) <Inner>
function create_default_slot_17(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("協和自動車へのお問い合わせまたは求人のご応募は、お電話か下記のフォームよりお問い合わせください。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "協和自動車へのお問い合わせまたは求人のご応募は、お電話か下記のフォームよりお問い合わせください。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (160:2) <Wrap>
function create_default_slot_16(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (159:0) <Section kind="top-small">
function create_default_slot_15(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (171:6) <Item>
function create_default_slot_14(ctx) {
	let div;
	let p0;
	let t0;
	let t1;
	let p1;
	let t2;

	return {
		c() {
			div = element("div");
			p0 = element("p");
			t0 = text("027-231-9008");
			t1 = space();
			p1 = element("p");
			t2 = text("お問い合わせ受付時間：平日（月〜金曜日）の10:00〜17:00　土曜・日曜・祝日は休み");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			p0 = claim_element(div_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "027-231-9008");
			p0_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p1 = claim_element(div_nodes, "P", {});
			var p1_nodes = children(p1);
			t2 = claim_text(p1_nodes, "お問い合わせ受付時間：平日（月〜金曜日）の10:00〜17:00　土曜・日曜・祝日は休み");
			p1_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p0, "class", "tel svelte-8g2x4x");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p0);
			append(p0, t0);
			append(div, t1);
			append(div, p1);
			append(p1, t2);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (169:4) <Inner>
function create_default_slot_13(ctx) {
	let heading;
	let t;
	let item;
	let current;
	heading = new Heading({ props: { name: "お電話でのお問い合わせ" } });

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (168:2) <Wrap>
function create_default_slot_12(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (167:0) <Section kind="top-small">
function create_default_slot_11(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (185:6) <Item>
function create_default_slot_10(ctx) {
	let div;
	let p0;
	let t0;
	let t1;
	let p1;
	let span;
	let t2;
	let t3;
	let t4;
	let p2;
	let t5;
	let a;
	let t6;

	return {
		c() {
			div = element("div");
			p0 = element("p");
			t0 = text("下記フォームにご記入の上送信してください。弊社よりご連絡させていただきます。");
			t1 = space();
			p1 = element("p");
			span = element("span");
			t2 = text("※");
			t3 = text("は必須項目です。お電話番号またはメールアドレスに入力ミスがありますとご連絡ができません。");
			t4 = space();
			p2 = element("p");
			t5 = text("お問い合わせいただいた方の個人情報は、ご連絡のため以外の目的で使用することはありません。");
			a = element("a");
			t6 = text("プライバシーポリシー");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", {});
			var div_nodes = children(div);
			p0 = claim_element(div_nodes, "P", {});
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "下記フォームにご記入の上送信してください。弊社よりご連絡させていただきます。");
			p0_nodes.forEach(detach);
			t1 = claim_space(div_nodes);
			p1 = claim_element(div_nodes, "P", {});
			var p1_nodes = children(p1);
			span = claim_element(p1_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t2 = claim_text(span_nodes, "※");
			span_nodes.forEach(detach);
			t3 = claim_text(p1_nodes, "は必須項目です。お電話番号またはメールアドレスに入力ミスがありますとご連絡ができません。");
			p1_nodes.forEach(detach);
			t4 = claim_space(div_nodes);
			p2 = claim_element(div_nodes, "P", {});
			var p2_nodes = children(p2);
			t5 = claim_text(p2_nodes, "お問い合わせいただいた方の個人情報は、ご連絡のため以外の目的で使用することはありません。");
			a = claim_element(p2_nodes, "A", { href: true, target: true });
			var a_nodes = children(a);
			t6 = claim_text(a_nodes, "プライバシーポリシー");
			a_nodes.forEach(detach);
			p2_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "require svelte-8g2x4x");
			attr(a, "href", "privacy-policy");
			attr(a, "target", "_blank");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p0);
			append(p0, t0);
			append(div, t1);
			append(div, p1);
			append(p1, span);
			append(span, t2);
			append(p1, t3);
			append(div, t4);
			append(div, p2);
			append(p2, t5);
			append(p2, a);
			append(a, t6);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (195:10) <Line name="お名前" required>
function create_default_slot_9(ctx) {
	let textinput;
	let updating_value;
	let current;

	function textinput_value_binding(value) {
		/*textinput_value_binding*/ ctx[13](value);
	}

	let textinput_props = {
		id: "your-name",
		name: "your-name",
		required: true
	};

	if (/*name*/ ctx[0] !== void 0) {
		textinput_props.value = /*name*/ ctx[0];
	}

	textinput = new TextInput({ props: textinput_props });
	binding_callbacks.push(() => bind(textinput, "value", textinput_value_binding));

	return {
		c() {
			create_component(textinput.$$.fragment);
		},
		l(nodes) {
			claim_component(textinput.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(textinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const textinput_changes = {};

			if (!updating_value && dirty & /*name*/ 1) {
				updating_value = true;
				textinput_changes.value = /*name*/ ctx[0];
				add_flush_callback(() => updating_value = false);
			}

			textinput.$set(textinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(textinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(textinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(textinput, detaching);
		}
	};
}

// (199:10) <Line name="会社名">
function create_default_slot_8(ctx) {
	let textinput;
	let updating_value;
	let current;

	function textinput_value_binding_1(value) {
		/*textinput_value_binding_1*/ ctx[14](value);
	}

	let textinput_props = { id: "company", name: "company" };

	if (/*company*/ ctx[1] !== void 0) {
		textinput_props.value = /*company*/ ctx[1];
	}

	textinput = new TextInput({ props: textinput_props });
	binding_callbacks.push(() => bind(textinput, "value", textinput_value_binding_1));

	return {
		c() {
			create_component(textinput.$$.fragment);
		},
		l(nodes) {
			claim_component(textinput.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(textinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const textinput_changes = {};

			if (!updating_value && dirty & /*company*/ 2) {
				updating_value = true;
				textinput_changes.value = /*company*/ ctx[1];
				add_flush_callback(() => updating_value = false);
			}

			textinput.$set(textinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(textinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(textinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(textinput, detaching);
		}
	};
}

// (203:10) <Line name="部署名">
function create_default_slot_7(ctx) {
	let textinput;
	let updating_value;
	let current;

	function textinput_value_binding_2(value) {
		/*textinput_value_binding_2*/ ctx[15](value);
	}

	let textinput_props = { id: "department", name: "department" };

	if (/*department*/ ctx[2] !== void 0) {
		textinput_props.value = /*department*/ ctx[2];
	}

	textinput = new TextInput({ props: textinput_props });
	binding_callbacks.push(() => bind(textinput, "value", textinput_value_binding_2));

	return {
		c() {
			create_component(textinput.$$.fragment);
		},
		l(nodes) {
			claim_component(textinput.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(textinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const textinput_changes = {};

			if (!updating_value && dirty & /*department*/ 4) {
				updating_value = true;
				textinput_changes.value = /*department*/ ctx[2];
				add_flush_callback(() => updating_value = false);
			}

			textinput.$set(textinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(textinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(textinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(textinput, detaching);
		}
	};
}

// (207:10) <Line name="電話番号" required>
function create_default_slot_6(ctx) {
	let telinput;
	let updating_value;
	let current;

	function telinput_value_binding(value) {
		/*telinput_value_binding*/ ctx[16](value);
	}

	let telinput_props = { id: "tel", name: "tel", required: true };

	if (/*tel*/ ctx[3] !== void 0) {
		telinput_props.value = /*tel*/ ctx[3];
	}

	telinput = new TelInput({ props: telinput_props });
	binding_callbacks.push(() => bind(telinput, "value", telinput_value_binding));

	return {
		c() {
			create_component(telinput.$$.fragment);
		},
		l(nodes) {
			claim_component(telinput.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(telinput, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const telinput_changes = {};

			if (!updating_value && dirty & /*tel*/ 8) {
				updating_value = true;
				telinput_changes.value = /*tel*/ ctx[3];
				add_flush_callback(() => updating_value = false);
			}

			telinput.$set(telinput_changes);
		},
		i(local) {
			if (current) return;
			transition_in(telinput.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(telinput.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(telinput, detaching);
		}
	};
}

// (211:10) <Line name="メールアドレス" required>
function create_default_slot_5(ctx) {
	let emailinput0;
	let updating_value;
	let t;
	let emailinput1;
	let updating_value_1;
	let current;

	function emailinput0_value_binding(value) {
		/*emailinput0_value_binding*/ ctx[17](value);
	}

	let emailinput0_props = {
		id: "email",
		name: "email",
		required: true,
		placeholder: "半角で入力してください"
	};

	if (/*email*/ ctx[4] !== void 0) {
		emailinput0_props.value = /*email*/ ctx[4];
	}

	emailinput0 = new EmailInput({ props: emailinput0_props });
	binding_callbacks.push(() => bind(emailinput0, "value", emailinput0_value_binding));

	function emailinput1_value_binding(value) {
		/*emailinput1_value_binding*/ ctx[18](value);
	}

	let emailinput1_props = {
		id: "email-check",
		name: "email",
		required: true,
		placeholder: "確認のためにもう一度メールアドレスを入力してください"
	};

	if (/*emailCheck*/ ctx[5] !== void 0) {
		emailinput1_props.value = /*emailCheck*/ ctx[5];
	}

	emailinput1 = new EmailInput({ props: emailinput1_props });
	binding_callbacks.push(() => bind(emailinput1, "value", emailinput1_value_binding));

	return {
		c() {
			create_component(emailinput0.$$.fragment);
			t = space();
			create_component(emailinput1.$$.fragment);
		},
		l(nodes) {
			claim_component(emailinput0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(emailinput1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(emailinput0, target, anchor);
			insert(target, t, anchor);
			mount_component(emailinput1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const emailinput0_changes = {};

			if (!updating_value && dirty & /*email*/ 16) {
				updating_value = true;
				emailinput0_changes.value = /*email*/ ctx[4];
				add_flush_callback(() => updating_value = false);
			}

			emailinput0.$set(emailinput0_changes);
			const emailinput1_changes = {};

			if (!updating_value_1 && dirty & /*emailCheck*/ 32) {
				updating_value_1 = true;
				emailinput1_changes.value = /*emailCheck*/ ctx[5];
				add_flush_callback(() => updating_value_1 = false);
			}

			emailinput1.$set(emailinput1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(emailinput0.$$.fragment, local);
			transition_in(emailinput1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(emailinput0.$$.fragment, local);
			transition_out(emailinput1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(emailinput0, detaching);
			if (detaching) detach(t);
			destroy_component(emailinput1, detaching);
		}
	};
}

// (216:10) <Line name="お問い合わせ内容（いずれか選択）" required>
function create_default_slot_4(ctx) {
	let radioinput;
	let updating_value;
	let t;
	let textarea;
	let updating_value_1;
	let current;

	function radioinput_value_binding(value) {
		/*radioinput_value_binding*/ ctx[19](value);
	}

	let radioinput_props = {
		id: "kind",
		name: "kind",
		kind: /*contactKind*/ ctx[10]
	};

	if (/*kind*/ ctx[6] !== void 0) {
		radioinput_props.value = /*kind*/ ctx[6];
	}

	radioinput = new RadioInput({ props: radioinput_props });
	binding_callbacks.push(() => bind(radioinput, "value", radioinput_value_binding));

	function textarea_value_binding(value) {
		/*textarea_value_binding*/ ctx[20](value);
	}

	let textarea_props = {
		id: "content",
		name: "content",
		placeholder: "備考欄",
		rows: "10",
		required: true
	};

	if (/*content*/ ctx[7] !== void 0) {
		textarea_props.value = /*content*/ ctx[7];
	}

	textarea = new TextArea({ props: textarea_props });
	binding_callbacks.push(() => bind(textarea, "value", textarea_value_binding));

	return {
		c() {
			create_component(radioinput.$$.fragment);
			t = space();
			create_component(textarea.$$.fragment);
		},
		l(nodes) {
			claim_component(radioinput.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(textarea.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(radioinput, target, anchor);
			insert(target, t, anchor);
			mount_component(textarea, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const radioinput_changes = {};

			if (!updating_value && dirty & /*kind*/ 64) {
				updating_value = true;
				radioinput_changes.value = /*kind*/ ctx[6];
				add_flush_callback(() => updating_value = false);
			}

			radioinput.$set(radioinput_changes);
			const textarea_changes = {};

			if (!updating_value_1 && dirty & /*content*/ 128) {
				updating_value_1 = true;
				textarea_changes.value = /*content*/ ctx[7];
				add_flush_callback(() => updating_value_1 = false);
			}

			textarea.$set(textarea_changes);
		},
		i(local) {
			if (current) return;
			transition_in(radioinput.$$.fragment, local);
			transition_in(textarea.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(radioinput.$$.fragment, local);
			transition_out(textarea.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(radioinput, detaching);
			if (detaching) detach(t);
			destroy_component(textarea, detaching);
		}
	};
}

// (226:10) {#if !validEmail}
function create_if_block(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("！メールアドレスが一致しません");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, "！メールアドレスが一致しません");
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "alert svelte-8g2x4x");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (193:6) <Item>
function create_default_slot_3(ctx) {
	let form;
	let line0;
	let t0;
	let line1;
	let t1;
	let line2;
	let t2;
	let line3;
	let t3;
	let line4;
	let t4;
	let line5;
	let t5;
	let t6;
	let submit_1;
	let current;
	let mounted;
	let dispose;

	line0 = new Line({
			props: {
				name: "お名前",
				required: true,
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	line1 = new Line({
			props: {
				name: "会社名",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	line2 = new Line({
			props: {
				name: "部署名",
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	line3 = new Line({
			props: {
				name: "電話番号",
				required: true,
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	line4 = new Line({
			props: {
				name: "メールアドレス",
				required: true,
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	line5 = new Line({
			props: {
				name: "お問い合わせ内容（いずれか選択）",
				required: true,
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	let if_block = !/*validEmail*/ ctx[8] && create_if_block(ctx);

	submit_1 = new Submit({
			props: {
				id: "submit",
				disabled: !/*validEmail*/ ctx[8]
			}
		});

	return {
		c() {
			form = element("form");
			create_component(line0.$$.fragment);
			t0 = space();
			create_component(line1.$$.fragment);
			t1 = space();
			create_component(line2.$$.fragment);
			t2 = space();
			create_component(line3.$$.fragment);
			t3 = space();
			create_component(line4.$$.fragment);
			t4 = space();
			create_component(line5.$$.fragment);
			t5 = space();
			if (if_block) if_block.c();
			t6 = space();
			create_component(submit_1.$$.fragment);
			this.h();
		},
		l(nodes) {
			form = claim_element(nodes, "FORM", { id: true, name: true, class: true });
			var form_nodes = children(form);
			claim_component(line0.$$.fragment, form_nodes);
			t0 = claim_space(form_nodes);
			claim_component(line1.$$.fragment, form_nodes);
			t1 = claim_space(form_nodes);
			claim_component(line2.$$.fragment, form_nodes);
			t2 = claim_space(form_nodes);
			claim_component(line3.$$.fragment, form_nodes);
			t3 = claim_space(form_nodes);
			claim_component(line4.$$.fragment, form_nodes);
			t4 = claim_space(form_nodes);
			claim_component(line5.$$.fragment, form_nodes);
			t5 = claim_space(form_nodes);
			if (if_block) if_block.l(form_nodes);
			t6 = claim_space(form_nodes);
			claim_component(submit_1.$$.fragment, form_nodes);
			form_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(form, "id", "form");
			attr(form, "name", "contact");
			attr(form, "class", "svelte-8g2x4x");
		},
		m(target, anchor) {
			insert(target, form, anchor);
			mount_component(line0, form, null);
			append(form, t0);
			mount_component(line1, form, null);
			append(form, t1);
			mount_component(line2, form, null);
			append(form, t2);
			mount_component(line3, form, null);
			append(form, t3);
			mount_component(line4, form, null);
			append(form, t4);
			mount_component(line5, form, null);
			append(form, t5);
			if (if_block) if_block.m(form, null);
			append(form, t6);
			mount_component(submit_1, form, null);
			current = true;

			if (!mounted) {
				dispose = listen(form, "submit", prevent_default(/*submit*/ ctx[11]));
				mounted = true;
			}
		},
		p(ctx, dirty) {
			const line0_changes = {};

			if (dirty & /*$$scope, name*/ 4194305) {
				line0_changes.$$scope = { dirty, ctx };
			}

			line0.$set(line0_changes);
			const line1_changes = {};

			if (dirty & /*$$scope, company*/ 4194306) {
				line1_changes.$$scope = { dirty, ctx };
			}

			line1.$set(line1_changes);
			const line2_changes = {};

			if (dirty & /*$$scope, department*/ 4194308) {
				line2_changes.$$scope = { dirty, ctx };
			}

			line2.$set(line2_changes);
			const line3_changes = {};

			if (dirty & /*$$scope, tel*/ 4194312) {
				line3_changes.$$scope = { dirty, ctx };
			}

			line3.$set(line3_changes);
			const line4_changes = {};

			if (dirty & /*$$scope, emailCheck, email*/ 4194352) {
				line4_changes.$$scope = { dirty, ctx };
			}

			line4.$set(line4_changes);
			const line5_changes = {};

			if (dirty & /*$$scope, content, kind*/ 4194496) {
				line5_changes.$$scope = { dirty, ctx };
			}

			line5.$set(line5_changes);

			if (!/*validEmail*/ ctx[8]) {
				if (if_block) {
					
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(form, t6);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			const submit_1_changes = {};
			if (dirty & /*validEmail*/ 256) submit_1_changes.disabled = !/*validEmail*/ ctx[8];
			submit_1.$set(submit_1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(line0.$$.fragment, local);
			transition_in(line1.$$.fragment, local);
			transition_in(line2.$$.fragment, local);
			transition_in(line3.$$.fragment, local);
			transition_in(line4.$$.fragment, local);
			transition_in(line5.$$.fragment, local);
			transition_in(submit_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(line0.$$.fragment, local);
			transition_out(line1.$$.fragment, local);
			transition_out(line2.$$.fragment, local);
			transition_out(line3.$$.fragment, local);
			transition_out(line4.$$.fragment, local);
			transition_out(line5.$$.fragment, local);
			transition_out(submit_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(form);
			destroy_component(line0);
			destroy_component(line1);
			destroy_component(line2);
			destroy_component(line3);
			destroy_component(line4);
			destroy_component(line5);
			if (if_block) if_block.d();
			destroy_component(submit_1);
			mounted = false;
			dispose();
		}
	};
}

// (183:4) <Inner>
function create_default_slot_2(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;
	heading = new Heading({ props: { name: "インターネットからのお問い合わせ" } });

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope, validEmail, content, kind, emailCheck, email, tel, department, company, name*/ 4194815) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (182:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope, validEmail, content, kind, emailCheck, email, tel, department, company, name*/ 4194815) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (181:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, validEmail, content, kind, emailCheck, email, tel, department, company, name*/ 4194815) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let script0;
	let script0_src_value;
	let script1;
	let script1_src_value;
	let script2;
	let t0;
	let t1;
	let nav;
	let t2;
	let div;
	let section0;
	let t3;
	let section1;
	let t4;
	let section2;
	let t5;
	let section3;
	let t6;
	let section4;
	let current;
	nav = new Nav({ props: { segment: "contact" } });

	section0 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_20] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "gapless",
				$$slots: { default: [create_default_slot_18] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			script0 = element("script");
			script1 = element("script");
			script2 = element("script");
			t0 = text("document.addEventListener('DOMContentLoaded', function() {\n      var form = document.getElementById('form');\n      form.addEventListener('submit', function() {\n        var email = document.getElementById('email').value;\n        var emailCheck = document.getElementById('email-check').value;\n        if(email != emailCheck) {\n          alert('メールアドレスが一致しません');\n          return;\n        }\n        var name = document.getElementById('your-name').value || '';\n        var company = document.getElementById('company').value || '';\n        var department = document.getElementById('department').value || '';\n        var tel = document.getElementById('tel').value || '';\n        var email = document.getElementById('email').value || '';\n        var content = document.getElementById('content').value || '';\n        var kinds = document.getElementsByName('kind');\n        var kind = '求人に関するお問い合わせ';\n        for(let i = 0; i < kinds.length; i++) {\n          if(kinds[i].checked) {\n            kind = kinds[i].value;\n            break;\n          }\n        }\n\n        var formData = new FormData();\n        formData.append('your-name', name);\n        formData.append('company', company);\n        formData.append('department', department);\n        formData.append('tel', tel);\n        formData.append('email', email);\n        formData.append('contact-kind', kind);\n        formData.append('content', content);\n\n        window.fetch('https://kyouwaji.com/wp/wp-json/contact-form-7/v1/contact-forms/5/feedback', {\n          method: 'POST',\n          body: formData\n        }).then(function(result) {\n          location.href = '/thanks';\n        }).catch(function(e) {\n          console.log(e);\n          alert('正しく送信できませんでした。もう一度お試し頂くか、電話にてお問い合わせください。');\n        });\n      });\n    });");
			t1 = space();
			create_component(nav.$$.fragment);
			t2 = space();
			div = element("div");
			create_component(section0.$$.fragment);
			t3 = space();
			create_component(section1.$$.fragment);
			t4 = space();
			create_component(section2.$$.fragment);
			t5 = space();
			create_component(section3.$$.fragment);
			t6 = space();
			create_component(section4.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-1rc7emm\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });

			script0 = claim_element(head_nodes, "SCRIPT", {
				nomodule: true,
				src: true,
				integrity: true,
				crossorigin: true
			});

			var script0_nodes = children(script0);
			script0_nodes.forEach(detach);
			script1 = claim_element(head_nodes, "SCRIPT", { nomodule: true, src: true, defer: true });
			var script1_nodes = children(script1);
			script1_nodes.forEach(detach);
			script2 = claim_element(head_nodes, "SCRIPT", { nomodule: true });
			var script2_nodes = children(script2);
			t0 = claim_text(script2_nodes, "document.addEventListener('DOMContentLoaded', function() {\n      var form = document.getElementById('form');\n      form.addEventListener('submit', function() {\n        var email = document.getElementById('email').value;\n        var emailCheck = document.getElementById('email-check').value;\n        if(email != emailCheck) {\n          alert('メールアドレスが一致しません');\n          return;\n        }\n        var name = document.getElementById('your-name').value || '';\n        var company = document.getElementById('company').value || '';\n        var department = document.getElementById('department').value || '';\n        var tel = document.getElementById('tel').value || '';\n        var email = document.getElementById('email').value || '';\n        var content = document.getElementById('content').value || '';\n        var kinds = document.getElementsByName('kind');\n        var kind = '求人に関するお問い合わせ';\n        for(let i = 0; i < kinds.length; i++) {\n          if(kinds[i].checked) {\n            kind = kinds[i].value;\n            break;\n          }\n        }\n\n        var formData = new FormData();\n        formData.append('your-name', name);\n        formData.append('company', company);\n        formData.append('department', department);\n        formData.append('tel', tel);\n        formData.append('email', email);\n        formData.append('contact-kind', kind);\n        formData.append('content', content);\n\n        window.fetch('https://kyouwaji.com/wp/wp-json/contact-form-7/v1/contact-forms/5/feedback', {\n          method: 'POST',\n          body: formData\n        }).then(function(result) {\n          location.href = '/thanks';\n        }).catch(function(e) {\n          console.log(e);\n          alert('正しく送信できませんでした。もう一度お試し頂くか、電話にてお問い合わせください。');\n        });\n      });\n    });");
			script2_nodes.forEach(detach);
			head_nodes.forEach(detach);
			t1 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t2 = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(section0.$$.fragment, div_nodes);
			div_nodes.forEach(detach);
			t3 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(section4.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "お問い合わせ | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社のお問い合わせ情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/contact/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "お問い合わせ | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社のお問い合わせ情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
			script0.noModule = true;
			if (script0.src !== (script0_src_value = "https://cdnjs.cloudflare.com/ajax/libs/es6-promise/3.3.1/es6-promise.min.js")) attr(script0, "src", script0_src_value);
			attr(script0, "integrity", "sha512-JMK7ImCd/9VxQM7FWvAT3njqo5iGKkWcOax6Bwzuq48xxFd7/jekKcgN+59ZRwBoEpZvv6Jkwh3fDGrBVWX5vA==");
			attr(script0, "crossorigin", "anonymous");
			script1.noModule = true;
			if (script1.src !== (script1_src_value = "https://cdnjs.cloudflare.com/ajax/libs/fetch/2.0.4/fetch.min.js")) attr(script1, "src", script1_src_value);
			script1.defer = true;
			script2.noModule = true;
			attr(div, "class", "hide-on-mobile");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			append(document.head, script0);
			append(document.head, script1);
			append(document.head, script2);
			append(script2, t0);
			insert(target, t1, anchor);
			mount_component(nav, target, anchor);
			insert(target, t2, anchor);
			insert(target, div, anchor);
			mount_component(section0, div, null);
			insert(target, t3, anchor);
			mount_component(section1, target, anchor);
			insert(target, t4, anchor);
			mount_component(section2, target, anchor);
			insert(target, t5, anchor);
			mount_component(section3, target, anchor);
			insert(target, t6, anchor);
			mount_component(section4, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 4194304) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope, validEmail, content, kind, emailCheck, email, tel, department, company, name*/ 4194815) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			detach(script0);
			detach(script1);
			detach(script2);
			if (detaching) detach(t1);
			destroy_component(nav, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div);
			destroy_component(section0);
			if (detaching) detach(t3);
			destroy_component(section1, detaching);
			if (detaching) detach(t4);
			destroy_component(section2, detaching);
			if (detaching) detach(t5);
			destroy_component(section3, detaching);
			if (detaching) detach(t6);
			destroy_component(section4, detaching);
		}
	};
}

const endpoint = "https://kyouwaji.com/wp/wp-json/contact-form-7/v1/contact-forms/5/feedback";

function instance($$self, $$props, $$invalidate) {
	let validEmail;

	var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
		function adopt(value) {
			return value instanceof P
			? value
			: new P(function (resolve) {
						resolve(value);
					});
		}

		return new (P || (P = Promise))(function (resolve, reject) {
				function fulfilled(value) {
					try {
						step(generator.next(value));
					} catch(e) {
						reject(e);
					}
				}

				function rejected(value) {
					try {
						step(generator["throw"](value));
					} catch(e) {
						reject(e);
					}
				}

				function step(result) {
					result.done
					? resolve(result.value)
					: adopt(result.value).then(fulfilled, rejected);
				}

				step((generator = generator.apply(thisArg, _arguments || [])).next());
			});
	};

	const paths = [{ name: "HOME", href: "/" }, { name: "お問い合わせ" }];

	const contactKind = [
		{
			id: "recruit",
			name: "求人に関するお問い合わせ",
			value: "求人に関するお問い合わせ",
			checked: true
		},
		{
			id: "car",
			name: "自動車の修理・整備・車検に関する問い合わせ",
			value: "自動車の修理・整備・車検に関する問い合わせ"
		}
	];

	let name = "";
	let company = "";
	let department = "";
	let tel = "";
	let email = "";
	let emailCheck = "";
	let kind = "求人に関するお問い合わせ";
	let content = "";
	let formData;

	onMount(() => {
		$$invalidate(12, formData = new FormData());
	});

	function submit() {
		return __awaiter(this, void 0, void 0, function* () {
			loading.set(true);
			const res = yield fetch(endpoint, { method: "POST", body: formData });

			if (res.ok) {
				loading.set(false);
				location.href = "/thanks";
			} else {
				alert("正しく送信できませんでした。もう一度お試し頂くか、電話にてお問い合わせください。");
			}

			loading.set(false);
		});
	}

	function textinput_value_binding(value) {
		name = value;
		$$invalidate(0, name);
	}

	function textinput_value_binding_1(value) {
		company = value;
		$$invalidate(1, company);
	}

	function textinput_value_binding_2(value) {
		department = value;
		$$invalidate(2, department);
	}

	function telinput_value_binding(value) {
		tel = value;
		$$invalidate(3, tel);
	}

	function emailinput0_value_binding(value) {
		email = value;
		$$invalidate(4, email);
	}

	function emailinput1_value_binding(value) {
		emailCheck = value;
		$$invalidate(5, emailCheck);
	}

	function radioinput_value_binding(value) {
		kind = value;
		$$invalidate(6, kind);
	}

	function textarea_value_binding(value) {
		content = value;
		$$invalidate(7, content);
	}

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*email, emailCheck*/ 48) {
			$: $$invalidate(8, validEmail = email === emailCheck);
		}

		if ($$self.$$.dirty & /*formData, name, company, department, tel, email, kind, content*/ 4319) {
			$: if (formData) {
				formData.set("your-name", name);
				formData.set("company", company);
				formData.set("department", department);
				formData.set("tel", tel);
				formData.set("email", email);
				formData.set("contact-kind", kind || "");
				formData.set("content", content);
			}
		}
	};

	return [
		name,
		company,
		department,
		tel,
		email,
		emailCheck,
		kind,
		content,
		validEmail,
		paths,
		contactKind,
		submit,
		formData,
		textinput_value_binding,
		textinput_value_binding_1,
		textinput_value_binding_2,
		telinput_value_binding,
		emailinput0_value_binding,
		emailinput1_value_binding,
		radioinput_value_binding,
		textarea_value_binding
	];
}

class Contact extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Contact;
//# sourceMappingURL=contact.svelte.js.map
